import { render, staticRenderFns } from "./ReceiveList.vue?vue&type=template&id=d33b55a0&"
import script from "./ReceiveList.vue?vue&type=script&lang=js&"
export * from "./ReceiveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports